export default __webpack_public_path__ + "static/media/home.a120e5a7.svg";